import { useTranslation } from 'react-i18next';

import { BodySmallText } from '../typography/typography';
import TaxiIcon from '../../assets/iconsComponent/TaxiIcon';
import { AssistanceNotificationStyle } from './assistance-notification-style';

//must be changed
interface AssistanceI {
  onTheWay?: boolean;
}

const MediaNotification: React.FC<AssistanceI> = ({ onTheWay }) => {
  const { t } = useTranslation(['assitance']);

  const getText = () => {
    return onTheWay ? t('assistance:notification.media-on-the-way') : t('assistance:notification.media-waiting');
  };
  return (
    <AssistanceNotificationStyle className="media">
      <TaxiIcon className="assistance-icon" />
      <BodySmallText className="assistance-text">{getText()}</BodySmallText>
    </AssistanceNotificationStyle>
  );
};

export default MediaNotification;
